<script>
import hoverDesign from '@/components/hoverDesign';

export default {
  name: 'demoBoothBanner',
  components: {
    hoverDesign
  },
  props: {
    demoId: {
      type: Number,
    },
    boothUrl: {
      type: String,
    }
  },
  methods: {
    openBooth() { window.open(this.boothUrl, '_blank'); },
  }
  
};
</script>

<template>
  <div class="demo-booth-banner" @click="openBooth">
    <div :class="`jacket is-${demoId}`"></div>
    <div class="items">
      <div class="text">
        <div>{{ $t(`message.demo.list.demo${demoId}.name`) }}</div>
        <div>{{ $t('message.demo.freeShort') }}</div>
      </div>
      <div class="booth-banner"></div>
    </div>
    
    <hover-design hover-design="checkered"/>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .demo-booth-banner {
    position: relative;
    width: 200px;
    height: 200px;
    overflow: hidden;
    cursor: pointer;
    .jacket {
      transition: 0.2s ease-out;
      @include absolute100;
      width: 100%;
      height: 100%;
      @include bgCenter;
      &.is-1 { background-image: url(../assets/img/demo/1.jpg); } 
      &.is-2 { background-image: url(../assets/img/demo/2.jpg); } 
      &.is-3 { background-image: url(../assets/img/demo/3.jpg); }
    }
    .items {
      transition: 0.2s ease-out;
      opacity: 1;
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content:flex-end;
      .text {
        padding: 5px 0;
        font-size: 0.8em;
        background: $bgColorA50;
      }

      .booth-banner {
        width: 200px;
        height: 40px;
        opacity: 0.8;
        @include bgCenter;
        background-image: url(../assets/img/banner/company/booth.png);
      }
    }

    &:hover {
      .jacket {
        transform: scale(1.1);
        filter: grayscale(100%);
      }
      .items {
        opacity: 0;
      }
    }
    

  }
</style>
